import { BECA } from "../actions/types";

const initialState = {
    listado: [],
    listado_requerimientos: [],
    detalles: null, 
    detalles_solicitud: null, 
    detalles_requerimiento: null, 
    detalles_archivo: null, 
    ventana_filtros: false, 
    filtros: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case BECA.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case BECA.BUSCAR_REQUERIMIENTOS:
            return {
                ...state,
                listado_requerimientos: payload
            };

        case BECA.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case BECA.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( beca => beca._id !== payload.id )
            };

        case BECA.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case BECA.BUSCAR_SOLICITUDES:
            return {
                ...state,
                detalles: {
                    ...state.detalles, 
                    solicitudes: payload
                }
            };

        case BECA.SOLICITUDES.DETALLES:
            return {
                ...state,
                detalles_solicitud: payload
            };

        case BECA.SOLICITUDES.REQUERIMIENTO.DETALLES:
            return {
                ...state, 
                detalles_requerimiento: payload
            };

        case BECA.SOLICITUDES.REQUERIMIENTO.STATUS:
            let solicitud_editar = state.detalles_solicitud;
            let requerimientos_editar = state.detalles_solicitud ? state.detalles_solicitud.requerimientos : [];
            requerimientos_editar.find( requerimiento => requerimiento._id === payload.id ).valor.status = payload.status;

            if(solicitud_editar){
                solicitud_editar = {
                    ...solicitud_editar, 
                    requerimientos: requerimientos_editar
                }
            }

            return {
                ...state,
                detalles_requerimiento: {
                    ...state.detalles_requerimiento, 
                    valor: {
                        ...state.detalles_requerimiento.valor, 
                        status: payload.status
                    }
                }, 
                detalles_solicitud: solicitud_editar
            };

        case BECA.SOLICITUDES.MENSAJES.LISTAR:
            return {
                ...state, 
                detalles_solicitud: {
                    ...state.detalles_solicitud, 
                    mensajes: payload
                }
            };

        case BECA.SOLICITUDES.MENSAJES.CREAR:
            let mensajes_agregar = state.detalles_solicitud.mensajes;

            mensajes_agregar = [
                ...mensajes_agregar, payload
            ];

            return {
                ...state, 
                detalles_solicitud: {
                    ...state.detalles_solicitud, 
                    mensajes: mensajes_agregar
                }
            };

        case BECA.SOLICITUDES.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case BECA.ARCHIVOS.LISTAR:
            return {
                detalles: {
                    ...state.detalles,
                    informacion_detallada: {
                        ...state.detalles.informacion_detallada,
                        archivos: [
                            ...payload.archivos
                        ]
                    }
                }
            };

        case BECA.ARCHIVOS.DETALLES:
            return {
                ...state,
                detalles_archivo: payload
            };

        default:
            return state;
    }
}